import { render, staticRenderFns } from "./IWarning.vue?vue&type=template&id=56e274db&scoped=true&"
import script from "./IWarning.vue?vue&type=script&lang=js&"
export * from "./IWarning.vue?vue&type=script&lang=js&"
import style0 from "./IWarning.vue?vue&type=style&index=0&id=56e274db&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e274db",
  null
  
)

export default component.exports